import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
  selector: "lib-data-table-span",
  templateUrl: "./span-cell-renderer.component.html",
  styleUrls: ["./span-cell-renderer.component.scss"]
})
export class SpanCellRendererComponent implements ICellRendererAngularComp {
  public params: any;

  public agInit(params: any): void {
    this.params = params;
  }

  public refresh(): boolean {
    return false;
  }
}
